import React from 'react';
import { ListColumnType, ListFilterType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import EnvironmentForm from './EnvironmentForm';
import EnvironmentDeleteIcon from './EnvironmentDeleteIcon';
import { useAllowedRight } from 'services/permissions/permissionChecks';

// Rename the name of the function:
const EnvironmentList: React.FC = () => {

    // Only superusers may create and edit environments, staff users can only view the list
    const isSuperuser = useAllowedRight('no_user');

    // Specify the options of this list:
    const query = {
        endpoint: 'get_environment_as_superuser_list',
        defaultParams: { 'is_active': true },
        object: 'environment_as_superuser'
    }
    const objectName = 'environment.general.object_name'
    const showSearch = true

    // Set isPaginated to true if this list may have 100.000+ items:
    const isPaginated = true

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        { width: '1fr', field: 'id', label: 'environment.general.environment_id_label' },
        { width: '9fr', field: 'name', label: 'environment.general.environment_name_label' },
        { width: '2rem', field: 'is_deletable', label: '', disableOrdering: true, render: (value, item) => <EnvironmentDeleteIcon row={item} /> },
    ];

    // Specify form, detail modal or detailpage for this list, staff users get no edit modal
    const formModal = <EnvironmentForm />;
    const onRowClick = isSuperuser ? 'editModal' : undefined

    // Specify the filters of this list:
    const filters: ListFilterType[] = [
        {
            id: 'active',
            label: 'environment.general.active_environments_filter_label',
            params: { 'is_active': true },
            default: true,
        },
        {
            group: 'environment.general.environment_status_filter_group_label',
            filters: [
                {
                    id: 'expired',
                    label: 'environment.status.expired',
                    params: { 'status': 'expired' },
                },
                {
                    id: 'suspended',
                    label: 'environment.status.suspended',
                    params: { 'status': 'suspended' },
                },
                {
                    id: 'cancelled',
                    label: 'environment.status.cancelled',
                    params: { 'status': 'cancelled' },
                },
            ]
        },
        {
            group: 'environment.general.environment_type_filter_group_label',
            filters: [
                {
                    id: 'trials',
                    label: 'environment.general.trial_environments_filter_label',
                    params: { 'type': 'trial' },
                },
                {
                    id: 'beta-environments',
                    label: 'environment.general.beta_environments_filter_label',
                    params: { 'type': 'beta' },
                },
                {
                    id: 'api-partner-environments',
                    label: 'environment.general.api_partner_environments_filter_label',
                    params: { 'type': 'api-partner' },
                },
                {
                    id: 'clients',
                    label: 'environment.general.client_environments_filter_label',
                    params: { 'type': 'client' },
                },
            ]
        },
        {
            group: 'general.archive',
            filters: [
                {
                    id: 'deactivated',
                    label: 'environment.general.deactivated_environments_filter_label',
                    shortName: 'general.deactivated',
                    params: { 'is_active': false },
                },
                {
                    id: 'deleted',
                    label: 'environment.general.deleted_environments_filter_label',
                    shortName: 'general.deleted',
                    params: { 'deletion_status': 'deleted' },
                }
            ]
        }
    ]

    return (
        <AbstractList
            query={query}
            objectName={objectName}
            filters={filters}
            columns={columns}
            showSearch={showSearch}
            showAddButton={isSuperuser}
            formModal={formModal}
            isPaginated={isPaginated}
            onRowClick={onRowClick}
        />
    );
};

export default EnvironmentList;